<template>
  <svg class="circular-progress" viewBox="0 0 36 36">
    <path class="bg" d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0 -31.831"/>
    <path class="progress" :style="progressStyle" d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831a 15.9155 15.9155 0 0 1 0 -31.831"/>
    <text x="18" y="20.35" class="percentage">{{ percentage }}%</text>
  </svg>
</template>

<script setup>
import { computed, defineProps } from 'vue';

const props = defineProps({
  percentage: {
    type: Number,
    required: true
  }
});

const progressStyle = computed(() => ({
  strokeDasharray: `${props.percentage}, 100`
}));
</script>

<style scoped>
.circular-progress {
  width: 40px;
  height: 40px;
}
.bg {
  fill: none;
  stroke: #ededed;
  stroke-width: 3.8;
}
.progress {
  fill: none;
  stroke: #E3FF00;
  stroke-width: 2.8;
  stroke-linecap: round;
  transition: stroke-dasharray 0.3s ease;
}
.percentage {
  fill: #000;
  font-size: 0.5em;
  text-anchor: middle;
}
</style>
